import { Routes } from '@angular/router';
import { AppPath } from '../../../app.routes';
import { AuthPath } from '../auth.routes';

export enum SignupSteps {
  Credentials = 'credentials',
  ContactInfo = 'contact-info',
  PlanSelection = 'plan-selection',
  Payment = 'payment',
}
export const nextStepLink = (currentStep: SignupSteps) => {
  const currentStepIndex = routes.findIndex((r) => r.path === currentStep);
  const nextStep = routes[currentStepIndex + 1];
  const nextStepPath = nextStep ? nextStep.path : null;

  return nextStepPath
    ? ['/', AppPath.Auth, AuthPath.SignUp, nextStepPath]
    : null;
};

export const previousStepLink = (currentStep: SignupSteps) => {
  const currentStepIndex = routes.findIndex((r) => r.path === currentStep);
  if (currentStepIndex <= 0) return null;
  const previousStep = routes[currentStepIndex - 1];
  const previousStepPath = previousStep?.path || null;

  return previousStepPath
    ? ['/', AppPath.Auth, AuthPath.SignUp, previousStepPath]
    : null;
};

const rawRoutes: Routes = [
  {
    path: SignupSteps.Credentials,
    loadComponent: () => import('./credentials/credentials.component'),
  },
  {
    path: SignupSteps.ContactInfo,
    loadComponent: () => import('./contact-info/contact-info.component'),
  },
  {
    path: SignupSteps.PlanSelection,
    loadComponent: () => import('./plan-selection/plan-selection.component'),
  },
  {
    path: SignupSteps.Payment,
    loadComponent: () => import('./payment/payment.component'),
  },
];

export const routes: Routes = [
  {
    path: '',
    redirectTo: SignupSteps.Credentials,
    pathMatch: 'full',
  },
  ...rawRoutes.map((route, index) => ({ ...route, data: { step: index + 1 } })),
];
